/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

var PARAMS = getUrlParams(window.location.search);
paramScrollTop(PARAMS); // do this earlier - when switching between frames (diff prods) maintain the same scroll level

 // fake this for Shopify Online Store Config screen
if (!window.meta) var meta = { product: { title: 'milestones', variants: [{price:8100, public_title: "10×8 / 4 Maps"}] }};

var TEMP = {};
var scrollFunctions = [];
var framedProducts = {
  milestones: ['po','bf','wf','cw','wfc','do'],
  summit: ['po','bf','wf','cw','wfc','do'],
  wanderlust: ['po','bf','wf','cw','wfc','do'],
  journey: ['po','bf','wf','cw','wfc','do'],
  heart: ['po','bf','wf','cw','wfc','do'],
  terra: ['po','bf','wf','cw','wfc','do']
};
var DE_OBJ = {};
var DELIVERY_ESTIMATES_RAW = `
{
    "art_normal_avg": 1.3,
    "art_normal_min": 0.68,
    "art_normal_max": 1.8,
    "art_priority_avg": 0.54,
    "art_priority_min": 0.37,
    "art_priority_max": 0.66,
    "prod_us_canvas_avg": 3.99,
    "prod_us_canvas_min": 1.47,
    "prod_us_canvas_max": 6.65,
    "_ship_SE_avg": 2.95,
    "_ship_SE_min": 1.78,
    "_ship_SE_max": 4.59,
    "_ship_NE_avg": 3.61,
    "_ship_NE_min": 2.52,
    "_ship_NE_max": 4.6,
    "prod_us_frame_avg": 1.77,
    "prod_us_frame_min": 1.17,
    "prod_us_frame_max": 2.34,
    "_ship_WE_avg": 5.19,
    "_ship_WE_min": 2.89,
    "_ship_WE_max": 7.43,
    "_ship_SW_avg": 4.52,
    "_ship_SW_min": 3.59,
    "_ship_SW_max": 5.55,
    "_ship_MW_avg": 4.71,
    "_ship_MW_min": 3.44,
    "_ship_MW_max": 6.55,
    "prod_us_print_avg": 2.09,
    "prod_us_print_min": 1.6,
    "prod_us_print_max": 2.32,
    "prod_canada_canvas_avg": 4.51,
    "prod_canada_canvas_min": 2.84,
    "prod_canada_canvas_max": 5.78,
    "_ship_canada_avg": 6.13,
    "_ship_canada_min": 1.65,
    "_ship_canada_max": 13.61,
    "_ship_MW_exp_avg": 4.55,
    "_ship_MW_exp_min": 2.78,
    "_ship_MW_exp_max": 6.59,
    "_ship_SE_exp_avg": 3.57,
    "_ship_SE_exp_min": 2.75,
    "_ship_SE_exp_max": 5.47,
    "_ship_WE_exp_avg": 4.51,
    "_ship_WE_exp_min": 3.03,
    "_ship_WE_exp_max": 5.65,
    "_ship_NE_exp_avg": 4.96,
    "_ship_NE_exp_min": 4.43,
    "_ship_NE_exp_max": 5.56,
    "_ship_SW_exp_avg": 3.72,
    "_ship_SW_exp_min": 2.53,
    "_ship_SW_exp_max": 4.67,
    "prod_europe_canvas_avg": 3.09,
    "prod_europe_canvas_min": 2.19,
    "prod_europe_canvas_max": 4.66,
    "_ship_europe_avg": 6.17,
    "_ship_europe_min": 3.64,
    "_ship_europe_max": 9.8,
    "prod_europe_frame_avg": 8.29,
    "prod_europe_frame_min": 5.8,
    "prod_europe_frame_max": 10.78,
    "prod_canada_frame_avg": 1.29,
    "prod_canada_frame_min": 0.9,
    "prod_canada_frame_max": 1.68,
    "prod_world_canvas_avg": 4.81,
    "prod_world_canvas_min": 2.13,
    "prod_world_canvas_max": 7.49,
    "_ship_world_avg": 16.12,
    "_ship_world_min": 5.2,
    "_ship_world_max": 27.03,
    "prod_canada_print_avg": 1.23,
    "prod_canada_print_min": 0.86,
    "prod_canada_print_max": 1.6,
    "_ship_APO_avg": 20.09,
    "_ship_APO_min": 14.06,
    "_ship_APO_max": 26.12,
    "_ship_canada_exp_avg": 0.97,
    "_ship_canada_exp_min": 0.68,
    "_ship_canada_exp_max": 1.26,
    "_us_canvas_min": 1.47,
    "_us_canvas_max": 6.65,
    "_us_print_min": 1.17,
    "_us_print_max": 2.34,
    "_canada_canvas_min": 4.49,
    "_canada_canvas_max": 19.39,
    "_canada_print_min": 2.51,
    "_canada_print_max": 15.21,
    "_europe_canvas_min": 5.83,
    "_europe_canvas_max": 14.46,
    "_europe_print_min": null,
    "_europe_print_max": null,
    "_world_canvas_min": 7.33,
    "_world_canvas_max": 34.52,
    "_world_print_min": null,
    "_world_print_max": null,
    "_australia_canvas_min": null,
    "_australia_canvas_max": null,
    "_australia_print_min": null,
    "_australia_print_max": null,
    "_NE_canvas_min": 3.99,
    "_NE_canvas_max": 11.25,
    "_NE_print_min": 4.12,
    "_NE_print_max": 6.92,
    "_SE_canvas_min": 3.25,
    "_SE_canvas_max": 11.24,
    "_SE_print_min": 3.38,
    "_SE_print_max": 6.91,
    "_SW_canvas_min": 5.06,
    "_SW_canvas_max": 12.2,
    "_SW_print_min": 5.19,
    "_SW_print_max": 7.87,
    "_WE_canvas_min": 4.36,
    "_WE_canvas_max": 14.08,
    "_WE_print_min": 4.49,
    "_WE_print_max": 9.75,
    "_MW_canvas_min": 4.91,
    "_MW_canvas_max": 13.2,
    "_MW_print_min": 5.04,
    "_MW_print_max": 8.87,
    "_ship_us_min": 1.78,
    "_ship_us_max": 7.43,
    "_NE_ship_exp_savings": -1.35,
    "_SE_ship_exp_savings": -0.62,
    "_SW_ship_exp_savings": 0.8,
    "_WE_ship_exp_savings": 0.68,
    "_MW_ship_exp_savings": 0.16,
    "_us_ship_exp_savings": -0.07,
    "_canada_ship_exp_savings": 5.16,
    "_art_min": 0.68,
    "_art_max": 3.18,
    "_priority_savings": 0.76,
    "_id": "675938f29160a50c667a6582",
    "__XMAS_is_holiday": true,
    "__XMAS_short_message": "Digital\nby Dec 14",
    "__XMAS_long_message": "As of Dec 11\nPrints & Frames: NO\nCanvas & Frm Canvas: NO\nDigital: YES"
}
`;
var DELIVERY_ESTIMATES = null;
try {
  DELIVERY_ESTIMATES_RAW = DELIVERY_ESTIMATES_RAW.replace(/\nby/g, '\\\\nby').replace(/\nC/g, '\\\\nC').replace(/\nP/g, '\\\\nP').replace(/\nD/g, '\\\\nD').replace(/\n\*/g, '\\\\n\*');
  var DELIVERY_ESTIMATES = JSON.parse(DELIVERY_ESTIMATES_RAW);
} catch (e) {/* do nothing */}

(function() {
  // Add custom code below this line
  initProduct();
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

function initProduct() {
  var page = solveProduct();

  if (page.product && page.product.title) { // only proceed on map/framed product pages
    selectPageFrameRadio();
    selectPageSizeRadio();
  	hideFrameTitle();
    // solveMapAddCost();
	  // renderAllLocations(true);
    loadProductCustomization(); // this call has race condition with cart variant ids loading.
    displayMapCountLocations();
    // renderNextLocationButton();
    // initLocationFeatures();
    initPriceChangeEvent();
    initMobilePriceTag();
    initProductCustomizationChanged();
    initValidation();
    validateLocations();
    fixCartBar(); // currently, cart-bar shows "configure" instead of "Add to Cart"
    initAddToCartSaveCustomization();
    // fixUpsellTitle();
    var removeFrameTextFromRelatedDesignsInterval = null;
	  var removedFrameTextFromRelated = false;
    tryRemoveFrameTextFromRelatedDesigns();
    addPersonalizedToTitles();
    // overrideRecentlyViewed();
    // boldSizeAndFrameLink();
    // initVariantImageSelection();
    // initVariantImageOverlay();
    // initDeliveryEstimate();
    initScrollDetect()
    initSplitTextField();
    initProductImageScrollFixed();
    setTimeout(function() {
      loadProductCustomization(); // repeat to set variant id for cart - especially for switching between frames
    }, 1000);
    setTimeout(function() {
      validateLocations();
    }, 250);
  } else if (location.pathname == '/') { // homepage
    hideProductFrameNamesHomepage();
  } else { // non map prod
  	hideCustomizationForNonMapProducts();
  }

  var cartCache = [];
  initCartRemoveRetrieveCustomization();
  // initCartValidation();
  initCartFormatting();
  loadCartCache();
  watchCartInit();
  // injectUpsells();
  initSingleLocationField();
  // initCartV2();
  // initCartV3();
  // initSingleTextField(); // 3/27 VWO test - this is worse.
  initCartNotifyMessage();
  // initMobileAddToCartTrayButtonFix(); // 4/3 VWO test this is worse, fix cart page instead. Future update floating checkout test
  // initTrayFixButton();
  initFloatingCartButton();
  initCartV4();
  // initUnlimitedRevisionsCheckbox();
}

// function initUnlimitedRevisionsCheckbox() {
//   // $('body').addClass('unlimited-rev-checkbox');
//   applyUnlimitedRevisionCheckbox();
//   setInterval(function() {
//     applyUnlimitedRevisionCheckbox()
//   }, 440);
// }

// function applyUnlimitedRevisionCheckbox() {
//   var $unlimited = $('#unlimited-rev');
//   if ($unlimited.length == 0) {
//     $('.form-cart').prepend(`
//       <div class="cart__widget" id="unlimited-rev">
//         <div class="cfg-modal-addon in-cart">
//           <label>
//             <span style="float:left;margin-left:14px;font-size:16px;margin-right:13px;">⭐</span>
//             Proof Approval + Unlimited Revisions
//           </label>
//         </div>
//       </div>
//     `);
//   }
// }

// function initCartV3() {
//   var $body = $('body');
//   if ($body.hasClass('cart-v3')) return;
//   $body.addClass('cart-v3');
//   setInterval(() => {
//     applyV3CartItem();
//   }, 371);
// }

// function applyV3CartItem() {
//   var $body = $('body');
//   if (!$body.hasClass('cart-v2')) return;
//   var $cartItems = $('.cart-item');
//   if ($cartItems.length == 0) return;
//   for (var i = 0; i < $cartItems.length; i++) {
//     var $cartItem = $($cartItems[i]);
//     var $mapCountTag = $cartItem.find(`.cart-item__selected-options.cartV3`);
//     if ($mapCountTag.length > 0) return;
  
//     var $locationLabel = $cartItem.find('strong:contains("Map Count:")');
//     var $locationAltLabel = $locationLabel.next(); // this one says "X Locations"
//     var $textLabel = $cartItem.find('span:contains("Text:"):first');
//     var $locationItem = $locationLabel.parent();
//     var $textItem = $textLabel.parent();
//     var $noteItem = $cartItem.find('#noteItem');
    
//     var $sizeTag = $cartItem.find(`strong:contains("Size:")`).parent();
//     var locationTagText = $locationAltLabel.text().replace('Location', 'Map');
//     $sizeTag.after(`
//       <p class="cart-item__selected-options cartV3">
//         <span>${locationTagText}</span>
//       </p>
//     `);
//     $cartItem.find('p.cart-item__selected-options.cartV3').prev().addClass('cartV3').prev().addClass('cartV3');
//     $locationAltLabel.text('Your ' + $locationAltLabel.text() + ':');
//     $textItem.find('span > div').css({ textAlign: 'left' });
//     $noteItem.css({ position: 'initial', outline: 'none', width: '100%' });
//     $locationItem.css({ outline: 'none' });
//     $textItem.css({ outline: 'none' }).hide();
//     $textItem.find('span > div').css({ textAlign: 'left' });
//     $cartItem.addClass('cartV3');
//   }
//   return;
// }

// function initCartV2() {
//   var $body = $('body');
//   if ($body.hasClass('cart-v2')) return;
//   $body.addClass('cart-v2');
// }

// function formatCartV2() {
//   var $body = $('body');
  
//   var $items = $('.cart-item[cartcacheindex]');
//   for (var i = 0; i < $items.length; i++) {
//     var $item = $($items.get(i));
//     if (!$item.hasClass('cart-v2')) {
//       $item.addClass('cart-v2');
//       var cartIndex = +$item.attr('cartcacheindex');
//       if (cartCache[cartIndex]) {
//         var cartCacheItem = cartCache[cartIndex];
//         var $mapCount = $item.find('strong:contains("Map Count:")');
//         var $mapCountTag = $mapCount.parent();
//         $mapCountTag.find('span:first').text($mapCountTag.find('span:first').text().replace('Maps', 'Locations'));
//         $mapCountTag.css({ 
//           width: '100%'
//         });
//         $mapCountTag.before('<br />');
//         $mapCountTag.append(`<span style="color:#6176e3;padding:3px;display:block;border-top:1px solid #ddd;">${cartCacheItem['properties[Locations]'].split('\n').join('</br>')}</span>`);
    
//         // check for notes - this is first, but will appear last in interface
//         var notes = '';
//         if (cartCacheItem["properties[Notes]"]) notes += `<div>${cartCacheItem["properties[Notes]"].split('\n').join('</br>')}</div>`;
//         if (notes) {
//           var $noteItem = $(`<p class="cart-item__selected-options" id="noteItem"><span>Notes:</span></p>`);
//           $noteItem.append(`<span style="color:#6176e3;padding:3px;display:block;border-top:1px solid #ddd;">${notes}</span>`);
//           $mapCountTag.after($noteItem);
//           $('#noteItem').css({
//             position: 'absolute',
//             left: '1px',
//             top: '141px',
//             width: '128px',
//             borderColor: 'white'
//           });
//         }
        
//         // check for text
//         var text = '';
//         if (cartCacheItem["properties[Main Text]"]) text += `<div style="font-size:14px;text-align:center;font-weight:600;">${cartCacheItem["properties[Main Text]"]}</div>`;
//         if (cartCacheItem["properties[Line 2]"]) text += `<div style="text-align:center;">${cartCacheItem["properties[Line 2]"]}</div>`;
//         if (cartCacheItem["properties[Line 3]"]) text += `<div style="text-align:center;">${cartCacheItem["properties[Line 3]"]}</div>`;
//         if (text) {
//           var $textItem = $(`<p class="cart-item__selected-options"><span>Text:</span></p>`);
//           $textItem.css({ width: '100%' });
//           $mapCountTag.after($textItem);
//           $mapCountTag.after(`<br />`);
//           $textItem.append(`<span style="color:#6176e3;padding:3px;display:block;border-top:1px solid #ddd;">${text}</span>`);
//         }
//       }
//     }
//   }
// }

function initFloatingCartButton() {
  $('body').addClass('floating-cart-button');
  $('.order-summary').remove();
  $('.product__submit__buttons').prepend(`
    <div class="order-summary hide">
      <span class="attribute summary-frame" onclick="$(window).scrollTop($('.fake-frame-select').position().top - 150)">Digital Only</span>
      <span>|</span>
      <span class="attribute summary-size" onclick="$(window).scrollTop($('.selector-wrapper[data-select-position=1]').position().top - 150)">10×8</span>
      <span>|</span>
      <span class="attribute summary-maps" onclick="$(window).scrollTop($('.selector-wrapper[data-select-position=2]').position().top - 150)">3 Maps</span>
    </div>
  `);
  scrollFunctions.push(assessFloatingCartButton);
}

function assessFloatingCartButton(e, scrollTop) {
  // collect these values once a second
  var scrollThreshold = $('.selector-wrapper[data-select-position="2"]').position().top;
  if (scrollTop > scrollThreshold) {
    $('.order-summary').removeClass('hide');
  } else {
    $('.order-summary').addClass('hide');
  }
}

// function initMilestonesImageSwap() { // for testing, no longer used
//   if ($('.flickity-slider').hasClass('altImgTest')) return console.log('already');
//   $('.flickity-slider').addClass('altImgTest');
//   var matches = [
//     {
//       replace: 'https://cdn.shopify.com/s/files/1/0060/6725/7434/files/5x4_4',
//       replace_v: '1711606856'
//     },
//     {
//       replace: 'https://cdn.shopify.com/s/files/1/0060/6725/7434/files/5x4_2',
//       replace_v: '1711606856'
//     },
//     {
//       replace: 'https://cdn.shopify.com/s/files/1/0060/6725/7434/files/5x4_3',
//       replace_v: '1711606856'
//     },
//     {
//       replace: 'https://cdn.shopify.com/s/files/1/0060/6725/7434/files/5x4_expect',
//       replace_v: '1711606856'
//     },
//     {
//       replace: 'https://cdn.shopify.com/s/files/1/0060/6725/7434/files/5x4_ugc',
//       replace_v: '1711606856'
//     },
//     {
//       replace: 'https://cdn.shopify.com/s/files/1/0060/6725/7434/files/5x4_maps',
//       replace_v: '1711606856'
//     },
//     {
//       replace: 'https://cdn.shopify.com/s/files/1/0060/6725/7434/files/5x4_sizing',
//       replace_v: '1711606856'
//     }
//   ];

//   for (var i = 0; i < matches.length; i++) {
//     var match = matches[i];
//     // var query = `div.product__slide[data-thumb^="${match.original}"]`;
//     // console.log(query); jQuery( ":nth-child(index/even/odd/equation)" )
//     var query = `div.flickity-slider div.product__slide[data-thumb]:nth-child(${i+2})`;
//     var $productSlideDiv = $(query);
//         console.log($productSlideDiv);

//     match.original = $productSlideDiv.attr('data-thumb').split('_200x')[0];
//     match.original_v = $productSlideDiv.attr('data-thumb').split('?v=')[1];
//     console.log(match);
//     console.log($productSlideDiv);
//     // console.log($productSlideDiv.length);
//     $productSlideDiv.attr('data-thumb', replaceImgUrl($productSlideDiv.attr('data-thumb'), match));
//     var $productPhotoDiv = $productSlideDiv.find('.lazy-image');
//     $productPhotoDiv.attr('data-image-src', replaceImgUrl($productPhotoDiv.attr('data-image-src'), match));
//     var $imgZoom = $productPhotoDiv.find('img[data-zoom]');
//     $imgZoom.attr('data-src', replaceImgUrl($imgZoom.attr('data-src'), match));
//     var $imgProd = $productPhotoDiv.find('img[data-product-image]');
//     console.log('imgprod', $imgProd);
//     $imgProd.attr('data-srcset', replaceImgUrl($imgProd.attr('data-srcset'), match));
//     $imgProd.attr('srcset', replaceImgUrl($imgProd.attr('srcset'), match));

//     // var $thumb = $(`a[href^="${match.original}"]`);
//     var $thumbDiv = $(`.thumbs-holder .thumb:nth-child(${i+2})`);
//     var $thumb = $thumbDiv.find('a.thumb__link');
//     $thumb.attr('href', replaceImgUrl($thumb.attr('href'), match));
//     var $thumbImage = $thumb.find('img.thumb__link__image');
//     $thumbImage.attr('src', replaceImgUrl($thumbImage.attr('src'), match));
//   }
// }

// function replaceImgUrl(urlString, match) {
//   var re = new RegExp(match.original, "g");
//   urlString = urlString.replace(re, match.replace);
//   var re2 = new RegExp(match.original_v, "g");
//   urlString = urlString.replace(re2, match.replace_v);
//   // var split = urlString.split('?v=');
//   // return split[0] + '?v=' + match.replace_v;
//   return urlString;
// }

// function initTrayFixButton() {
//   $('#cart-bar').find('[data-product-price]').on('click', function() {
//     initMobileAddToCartTrayButtonFix();
//   });
// }

// function initMobileAddToCartTrayButtonFix() {
//   console.log('initMobileAddToCartButtonFix');
//   var $cartBar = $('#cart-bar');
//   if ($cartBar.hasClass('iosCartRedirectFix')) return;

//   $cartBar.addClass('iosCartRedirectFix');
//   // on iOS when scrolling past the add to cart button, the floating add to cart button redirects to /cart/add instead of using the nice drawer.
//   // this fix replaces that broken button
//   var $button = $('#cart-bar').find('button[name="add"]');
//   var $cloneButton = $button.clone();
//   $cloneButton.attr('name', 'addClone');
  
//   $cloneButton.on('click', function() {
//     var $myClone = $('#cart-bar').find('button[name="addClone"]');
//     if ($myClone.hasClass('is-loading')) return;
    
//     $('.product__submit__item').find('button[name="add"]').click();
//     $myClone.addClass('is-loading');
//     setTimeout(function(){
//       $myClone.removeClass('is-loading');
//     }, 2500);
//   });

//   $cloneButton.append(`<span style="position: absolute; left:0; bottom:0; background-color: black; opacity:0.1; height:10px; width:10px; border-radius:15px;"></span>`)
//   $button.after($cloneButton);
//   $button.remove();
// }

function initCartNotifyMessage() {
  var $form = $('form.product-form');
  if ($form.hasClass('cartNotify')) return;
  
  // add cartNotify class
  $('form.product-form').addClass('cartNotify');
  setInterval(function() {
    checkCartNotify();
  }, 500);
}

function checkCartNotify() {
  var $remove = $('a.cart-item__remove');
  if ($remove.length > 0) {
    $('form.product-form').addClass('hasCart');
    $('.cart__icon__content').addClass('throb');
  } else {
    $('form.product-form').removeClass('hasCart');
    $('.cart__icon__content').removeClass('throb');
  }
}

function editCartFromNotify() {
  $('a.cart-item__remove')[0].click();
  setTimeout(function() {
    if ($('.cart-item__remove').length == 0) {
      $('.cart-dropdown__close')[0].click();
    }
  }, 2000);
}

function initSingleLocationField() {
  var $form = $('form.product-form');
  if ($form.hasClass('singleLocation')) return;
  
  // add singleLocation class
  $('form.product-form').addClass('singleLocation');
  // remove "Maps" from select options
  var $spans = $('[data-select-position="2"] label span');
  for (var i = 0; i < $spans.length; i++) {
    var $span = $($spans[i]);
    $span.text($span.text().trim().replace(' Maps', ''));
    $span.text($span.text().trim().replace(' Map', ''));
  }

  // Move mapcount
  var $personalization = $('.map-info.personalization').detach();
  $('.map-info.locations').after($personalization);

  // add title to mapcount
  $('[data-select-position="2"]').before('<h6>Location Count</h6>');

  // change "Personalization" header to "your text"
  $('.map-info.personalization h6').text('Your Text');

  $('#location_1').removeClass('required');

  $('header.cart-dropdown__head h3').text('Your Cart').css({ fontSize: '.8em', lineHeight: '10px' });

  $('button#nextLocationButton').remove();
  $('.add-location-cost').remove();

  $('.loox-rating').css({ cursor: 'pointer' }).on('click', function() {
    $('.loox-rating').parent().click();
  });
}

function initSingleTextField() {
  var $form = $('form.product-form');
  if ($form.hasClass('singleText')) return;
  
  // add singleLocation class
  $('form.product-form').addClass('singleText');
}

function initSplitTextField() {
  var $form = $('form.product-form');
  if ($form.hasClass('splitText')) return;
  
  // add singleLocation class
  $('form.product-form').addClass('splitText');

  // remove old note
  $('.old-location-note').remove();

  reflectSplitTextField();
}

function reflectSplitTextField() {
  var placeholders = [
    '1. Tokyo, Japan',
    '2. Phoenix, AZ',
    '3. Disney World, FL',
    '4. Grand Canyon',
    '5. Juneau, AK',
    '...'
  ];
  var $selectedRadio = $('input[name="options[Map Count]"]:checked');
  var mapCount = +$selectedRadio.attr('value').split(' ')[0];

  // $('textarea[name="properties[Locations]"]').attr('placeholder', placeholders.slice(0, mapCount).join('\n')).attr('rows', (mapCount > 8) ? 8 : mapCount);

  var $locations = $('textarea[name="properties[Locations]"]');
  var $info = $locations.next();

  var infoHtml = `example:</br>` + placeholders.slice(0, mapCount).join('</br>');
  
  if ($locations.val()) {
    $info.html(infoHtml);
  } else {
    $info.html(`👈 type here`);
  }

  var $text = $('textarea[name="properties[Text]"]');
  var $textInput = $('input[name="properties[Main Text]"]');
  var $textInfo = $text.next();
  if ($text.val() || $textInput.val() || !$('form.product-form').hasClass('singleText')) { // always show example
    $textInfo.html(`example:</br>Our Journey</br>The Jorgensons</br>10.13.2022`);
  } else {
    $textInfo.html(`👈 type here`);
  }
}

function initPriceChangeEvent() {
  $('input[type=radio]').on('change', function() {
    updateMobilePriceTag();
    reflectSplitTextField();
  });
}

function initScrollDetect() {
  $(window).on("scroll", function(e) {
    for (var i = 0; i < scrollFunctions.length; i++) {
       scrollFunctions[i](e, $(window).scrollTop()); 
    }
  });
}

function mobilePriceTagDetect(e, scrollTop) {
  if (scrollTop > 30) scrollTop = 30;
  var $mobilePriceTag = $('.mobilePriceTag');
  $mobilePriceTag.css({
    height: scrollTop+'px',
    bottom: (5-scrollTop) + 'px'
  });
}

function initMobilePriceTag() {
  $('header').prepend('<div class="mobilePriceTag"><span></span></div>');
  updateMobilePriceTag();
  scrollFunctions.push(mobilePriceTagDetect);
}

function initProductImageScrollFixed() {
  if (TEMP.initProductImageScrollFixed) return;
  TEMP.initProductImageScrollFixed = true;
  var windowWidth = $(window).outerWidth();
  if (windowWidth <= 749) return;
  scrollFunctions.push(productImageScrollFixed);
}

function productImageScrollFixed(e, scrollTop) {
  // collect these values once a second
  var timestamp = new Date().getTime();
  if (timestamp - TEMP.lastProductImageScrollFixed > 1000) {
    delete TEMP.scrollTop;
    delete TEMP.mainImgHeight;
    delete TEMP.mainImgY;
    delete TEMP.thumbsHeight;
    delete TEMP.columnHeight;
    delete TEMP.maxMarginTop;
  }
  TEMP.lastProductImageScrollFixed = timestamp;

  // collect values
  if (!TEMP.scrollTop) TEMP.scrollTop = scrollTop;
  if (!TEMP.mainImgHeight) TEMP.mainImgHeight = $('.product__slides').outerHeight();
  if (!TEMP.mainImgY) TEMP.mainImgY = $('.product__slides').position().top;
  if (!TEMP.thumbsHeight) TEMP.thumbsHeight = $('.product__thumbs--square').outerHeight();
  if (!TEMP.columnHeight) TEMP.columnHeight = $('.grid__item:first').outerHeight();
  if (!TEMP.maxMarginTop) TEMP.maxMarginTop = TEMP.columnHeight - (TEMP.thumbsHeight + TEMP.mainImgHeight);
  
  // update the new scroll;
  var marginTop = scrollTop;
  if (marginTop > TEMP.maxMarginTop) marginTop = TEMP.maxMarginTop;
  $('.product__slides').css({ marginTop: marginTop });
}

function updateMobilePriceTag() {
  setTimeout(function() { // price updates after a brief delay
  	$('.mobilePriceTag span').text($('.product__price:first span[data-product-price]').text());
    var frame = $('[name="frame"]:checked').attr('value');
    var size = $('[name="options[Size]"]:checked').attr('value');
    var maps = $('[name="options[Map Count]"]:checked').attr('value');
    $('.order-summary .attribute.summary-frame').text(frame);
    $('.order-summary .attribute.summary-size').text(size);
    $('.order-summary .attribute.summary-maps').text(maps);
  }, 150);
}

function solveProduct() { // builds the data about this product into Shopify's meta var
  var pageProduct = getPageProduct();
  if (pageProduct) {
    meta.product.title = pageProduct;
  }
  return meta;
}
function getPageHandle() {
  return location.pathname.split('/')[location.pathname.split('/').length-1];
}
function getPageBaseHandle() { // return milestones-map if handle = milestones-map-wf
  var handle = getPageHandle();
  var dashSplit = handle.split('-');
  var shortFrame = getPageFrame(); // e.g. bf
  if (dashSplit[dashSplit.length-1] == shortFrame) {
    return handle.substring(0, handle.length - (shortFrame.length+1));
  } else {
    return handle;
  }
}

function getPageFrame() {
  var pageHandle = getPageHandle();
  var pageProduct = getPageProduct(); // single word e.g. milestone
  var frames = framedProducts[pageProduct];
  var dashSplit = pageHandle.split('-');
  if (!frames.includes(dashSplit[dashSplit.length-1])) {
    return 'do';
  }
  return dashSplit[dashSplit.length-1];
}

function isFramedPage() {
  var pageProduct = getPageProduct();
  return pageProduct ? true : false;
}

function getPageProduct() {
  var pageHandle = location.pathname.split('/')[location.pathname.split('/').length-1];
  for (var product in framedProducts) {
    if (pageHandle.toLowerCase().includes(product)) {
      return product;
    }
  }
  return '';
}

function selectPageFrameRadio() {
  var pageFrame = getPageFrame();
  var $radios = $('[type=radio][name=frame]');
  for (var i = 0; i < $radios.length; i++) {
    var radio = $radios[i];
    var shortFrame = $(radio).attr('value').split(' ').map(word => word[0]).join('').toLowerCase();

    if (pageFrame == shortFrame) $(radio).prop("checked", true);
  }
}

function selectPageSizeRadio() {
  var $radios = $('[type=radio][name="options[Size]"]');
  var $selected = $('[type=radio][name="options[Size]:checked"]');
  if (!$selected.length) {
    $($radios[0]).prop('checked', true);
  }

  var $mcRadios = $('[type=radio][name="options[Map Count]"]');
  var $mcSelected = $('[type=radio][name="options[Map Count]:checked"]');
  if (!$mcSelected.length) {
    $($mcRadios[0]).prop('checked', true);
  }
}

function loadFramePage(frame) { // frame = 'wf'
  if (!isFramedPage()) return;
  // assume default url is black frame - and url has no suffix e.g. milestones-wf
  var shortFrame = frame;
  var pageShortFrame = getPageFrame();

  if (pageShortFrame == shortFrame) return; // do nothing - already on page
  $('#loadingOverlay').fadeIn(400);
  // direct to new url

  var hrefLeft = location.href.split('?')[0];
  var urlArr = location.href.split('?')[0].split('/');
  console.log(hrefLeft, urlArr, pageShortFrame, shortFrame);
  urlArr.pop(); // remove last element
  urlArr.push(getPageBaseHandle());

  var newUrl = urlArr.join('/');
  if (shortFrame != 'do') newUrl += `-${shortFrame}`; // bf variants are the base url without -wf

  // add scrollTop and other params to persist
  var params = window.location.search;
  params = setUrlParam(params, 'scrollTop', $(window).scrollTop());

  setTimeout(function() {
    var nextUrl = `${newUrl}?${params}`;
    console.log(newUrl);
    window.location.replace(nextUrl); // replace() allows for redirect, but no history of it (browser back)
  }, 400);
  setTimeout(function() {
  	// if for some reason, nav to page and fadeIn stuck, unstuck it
    $('#loadingOverlay').fadeOut(400);
  }, 2000);
}

function hideFrameTitle() { // products will sometimes have titles of the variant [black frame] hide anything in brackets
  $('h1.product__title').text($('h1.product__title').text().split('[')[0]);
}

function getUrlParams(params) {
  // if (!params) params = window.location.search;
  if (params[0] != '?') params = '?' + params;

  var url = params;
  var paramSplit2 = (url.split('?')[1]) ? url.split('?')[1].split('&') : [];
  var result = {};
  var paramSplit3 = paramSplit2.forEach((item) => { // count=13
    var itemSplit = item.split('=');
    var key = decodeURIComponent(itemSplit[0].replace(/\+/g, ' '));
    var value = itemSplit[1];
    if (value == undefined || value == null) value = '';
    result[key] = decodeURIComponent(value.replace(/\+/g, ' '));
  });
  return result;
};
function setUrlParam(params, name, value) { // pushes param changes to url
  var paramObj = getUrlParams(params);
  paramObj[name] = value;
  return paramsToUrl(paramObj);
};

function paramsToUrl(paramObj) {
  var result = '';
  Object.keys(paramObj).forEach((key) => {
    if (key === undefined || key === null) return;
    if (paramObj[key] != null && paramObj[key] != undefined && paramObj[key] != '') {
      if (result != '') result += '&';
      result += `${key}${(paramObj[key]) ? '='+encodeURIComponent(paramObj[key]) : ''}`;
    }
  });
  return result;
}

function paramScrollTop(params) {
  if (params.scrollTop !== undefined) {
    $(window).scrollTop(+params.scrollTop);
    delete params.scrollTop;
	var newParamsString = paramsToUrl(params);
    window.history.replaceState(null, document.title,  window.location.pathname + '?' + newParamsString);
  }
}

// function solveMapAddCost() {
//   // run this first, uses var meta to calculate each location's relative cost to base locations
//   // file into cost by size
//   var sizes = {};
//   for (var i = 0; i < meta.product.variants.length; i++) {
//     // solve for size & maps
//     var size = meta.product.variants[i].public_title.split(' / ')[0];
//     var mapCount = meta.product.variants[i].public_title.split(' / ')[1].split(' ')[0];
//     if (!sizes[size]) sizes[size] = {};
//     sizes[size][mapCount] = meta.product.variants[i].price;
//   }

//   // we'll want to use the size with the most map count as basis
//   var maxOptionCount = 0;
//   var maxOptionCountSize = '';
//   var startCount = '';
//   Object.keys(sizes).forEach((size, i) => {
//     if (Object.keys(sizes[size]).length >= maxOptionCount) {
//       startCount =
//       maxOptionCount = Object.keys(sizes[size]).length;
//       maxOptionCountSize = size;
//     }
//   });

//   // now lets calculate the delta for each additional size
//   // 1. sort into an array
//   var sizePrices = [];
//   Object.keys(sizes[maxOptionCountSize]).forEach((size) => {
//     sizePrices.push({
//       mapCount: +size,
//       price: sizes[maxOptionCountSize][size]
//     });
//   });
//   console.log(sizePrices);
//   var sortedSizePrices = sizePrices.sort((a, b) => {
//     return (+a.mapCount > +b.mapCount) ? 1 : -1;
//   });

//   // now, compute each delta from previous price
//   var previousPrice = sortedSizePrices[0].price;
//   sortedSizePrices.forEach((mapCountObj, i) => {
//     mapCountObj.delta = mapCountObj.price - previousPrice;
//     previousPrice = mapCountObj.price;

//     var $input = $(`input[name="options[Map Count]"][value^="${mapCountObj.mapCount} Map"]`);
//     // add the delta to each location
//     $input.attr('delta', mapCountObj.delta);

//     $input.attr('mapCount', mapCountObj.mapCount);

//     // denote max and min radios
//     if (i == 0) $input.addClass('mapCount-min');
//     if (i == sortedSizePrices.length -1) $input.addClass('mapCount-max');
//   });
// }

function displayMapCountLocations() {
  var placeholders = [
    '1. Tokyo, Japan',
    '2. Phoenix, AZ',
    '3. Disney World, FL',
    '4. Grand Canyon',
    '5. Juneau, AK',
    '6. First Lutheran Church, Eau Claire, WI',
    '7. Luxembourg',
    '...'
  ];
  
  var $selectedRadio = $('input[name="options[Map Count]"]:checked');
  if (!$selectedRadio.length) {
    $('input[name="options[Map Count]"]:first').click();
  }
  var mapCount = +$selectedRadio.attr('value').split(' ')[0];
  // find the corresponding location fields
  var $locations = $('.location-div');
  for (var i = 0; i < $locations.length; i++) {
    var $location = $($locations[i]);
    var locationNum = +$location.attr('id').split('_')[1];
    if (locationNum <= mapCount) {
      $location.prop('disabled', false).show();
	} else {
      $location.prop('disabled', true).hide();
    }
  }
  $('.location-count').text(mapCount);

  // change the locations textarea placeholder
  $('textarea[name="properties[Locations]"]').attr('placeholder', placeholders.slice(0, mapCount).join('\n')).attr('rows', (mapCount > 8) ? 8 : mapCount);
  
}

// function selectNextMapCount() {
//   var max = +$('.mapCount-max').attr('mapCount');
//   var current = +$('input[name="options[Map Count]"]:checked').attr('mapCount');
//   if (current < max) {
//     $(`input[name="options[Map Count]"][mapCount=${current+1}]`).prop('checked', true)[0].dispatchEvent(new Event('change'));
//     displayMapCountLocations();
//     renderNextLocationButton();
//     renderLocation(current+1, true);
//     validateLocations();
//     var $input = $(`#location_${current+1} input`);
//     if ($input.val().length) {
//       $input.select();
//     } else {
//       $input.val('').select();
//     }
//   }
// }

// function selectPreviousMapCount() {
//   var min = +$('.mapCount-min').attr('mapCount');
//   var current = +$('input[name="options[Map Count]"]:checked').attr('mapCount');
//   if (current > min) {
//     $(`input[name="options[Map Count]"][mapCount=${current-1}]`).prop('checked', true)[0].dispatchEvent(new Event('change'));
//     displayMapCountLocations();
//     renderNextLocationButton();
//     validateLocations();
//   }
// }

// function renderNextLocationButton() {
//   var $button = $('#nextLocationButton');
//   var max = +$('.mapCount-max').attr('mapCount');
//   var current = +$('input[name="options[Map Count]"]:checked').attr('mapCount');
//   if (current < max) {
//     $button.show();
//     var next = current+1;
//     var $next = $(`input[name="options[Map Count]"][mapCount=${next}]`);
//     var nextAmt = +$next.attr('delta');
//     if (nextAmt) {
//       $('.add-location-cost').show().text(`+$${(nextAmt/100).toFixed(2)}`);
//     }
//     $button.find('span').text(next);
//   } else {
//     $button.hide();
//     $('.add-location-cost').hide();
//   }
//   $('.location-count-range span').text(max);
// }

// function renderLocation(locationNum, pre) { // is it empty? is it ok?
//   var min = +$('.mapCount-min').attr('mapCount');
//   var max = +$('.mapCount-max').attr('mapCount');
//   var $location = $(`#location_${locationNum}`);
//   var $remove = $location.find('.location-remove');
//   var $input = $location.find('input');
//   if (locationNum > min) {
//     $remove.show();
//   } else {
//     $remove.hide();
//   }

//   if ($input.val() == '') {
//   	$location.removeClass('ok');
//     if (!pre) {
//       $location.addClass('required');
//     } else {
//       $location.removeClass('required');
//     }
//   } else {
//     $location.addClass('ok').removeClass('required');
//   }
// }

// function renderAllLocations(pre) { // pre is something called at start - won't mark things "required" if missing, as that is too harsh on page load
//   var max = +$('.mapCount-max').attr('mapCount');
//   for (var i = 0; i <= max; i++) {
//     renderLocation(i, pre);
//   }
// }

// function initLocationFeatures() {
//   var $inputs = $('.location-div input');
//   $inputs.on('blur keyup change', function(e) {
//     renderLocation($(e.target).parent().attr('id').split('_')[1]);
//   });
// }

// function removeLocation(locationNum) {
//   // per location only available on empty locations - can shifts other locations up or down
//   var max = +$('.mapCount-max').attr('mapCount');
//   // if location num has locations ahead of it, start moving them down into the current slot
//   for (var i = +locationNum; i < max; i++) {
//     var $input = $(`#location_${i} input`);
//     var $nextInput = $(`#location_${i+1} input`);
//     $input.val($nextInput.val());
//   }
//   // finally delete the final spot
//   $(`#location_${max} input`).val('');
//   renderLocation(locationNum);
//   selectPreviousMapCount();
// }

function getProductCustomization() {
  var $saveables = $('.saveable');
  var data = {};
  // solve frame & size
  data.size = $('input[type=radio][data-index=option1]:checked').attr('value');
  data.mapCount = $('input[type=radio][data-index=option2]:checked').attr('value');

  for (var i = 0; i < $saveables.length; i++) {
    var $saveable = $($saveables[i]);
    var value = $saveable.val();
    if (value != '' && value !== undefined) {
      data[$saveable.attr('name')] = value;
    }
  }
  console.log(data);
  return data;
}

function saveProductCustomization(key = 'savedCustomization') {
  if (!localStorage) return;
  var data = getProductCustomization();

  // see if it's empty and worth saving - if empty there's a chance it clears the saved value on reload
  var dataTest = Object.assign({}, data);
  delete dataTest.mapCount;
  delete dataTest.size;
  if (JSON.stringify(dataTest) == '{}') return;

  localStorage.setItem(key, JSON.stringify(data));
  return JSON.stringify(data);
}

function loadProductCustomization(key = 'savedCustomization') {
  if (!localStorage) return;
  var saved = localStorage.getItem(key);
  if (saved) {
    var savedObj = JSON.parse(saved);
    fillProductCustomization(savedObj);
  }
}

function fillProductCustomization(savedObj) {
  $('.saveable').val('');
  if (savedObj.size) {
    var $radio1 = $(`input[type=radio][name="options[Size]"][value="${savedObj.size}"]`);
    if ($radio1.length) $radio1.prop('checked', true)[0].dispatchEvent(new Event('change'));
  }
  if (savedObj.mapCount) {
    var $radio2 = $(`input[type=radio][name="options[Map Count]"][value="${savedObj.mapCount}"]`);
    if ($radio2.length) $radio2.prop('checked', true)[0].dispatchEvent(new Event('change'));
  }
  Object.keys(savedObj).forEach((key) => {
    var $input = $(`[name="${key}"]`);
    $input.val(savedObj[key]);
    // var $location = $input.parent();
    // if ($location.attr('id') && $location.attr('id').includes('location_')) {
    //   renderLocation($location.attr('id').split('_')[1]);
    // }
  });
  validateLocations();
}

function clearProductCustomization(key = 'savedCustomization') {
  if (!localStorage) return;
  localStorage.removeItem(key);
  $('.saveable').val('');
  // $('.mapCount-min').prop('checked', true)[0].dispatchEvent(new Event('change'));
  displayMapCountLocations();
  validateLocations();
  // renderAllLocations(true);
  // renderNextLocationButton();
}

function initProductCustomizationChanged() {
  var throttledSave = throttle(saveProductCustomization, 300, { leading: true });
  var throttledValidate = throttle(validateLocations, 200, { leading: true });
  $('.saveable').on('blur keyup change', function() {
    throttledSave();
    throttledValidate();
  });
  $('input[type=radio]').on('change', function() {
    displayMapCountLocations();
    throttledSave();
  });
}

function validateLocations() {
  reflectSplitTextField();
  // NEW 3/5/2024 - only check if location_1 is filled out
  var $form = $('form.product-form');
  if ($form.hasClass('singleLocation')) {
    var $location1 = $('#location_1 textarea');
    if ($location1.val()) {
      $('.location-count').addClass('validationPassed');
      $('button[name=add]').show();
      $('button[name="addClone"]').show();
      $('.validationFailButton').hide();
    } else {
      $('.validationFailButton').show();
      $('button[name=add]').hide();
      $('button[name="addClone"]').hide();
      $('.location-count').removeClass('validationPassed');
    }
    return;
  }
  
  // choosing to not validate Main Text, if all locations are filled out the cust has thought it through already.
  var $mapCountRadio = $(`input[type=radio][name="options[Map Count]"]:checked`);
  var mapCount = +$mapCountRadio.val().split(' ')[0];
  var valid = true;
  var $invalidLocation = null;
  for (var i = 1; i <= mapCount; i++) {
    var $location = $(`div#location_${i}`);
    var $input = $location.find('input');
    var value = $input.val();
    if (value == '') {
      valid = false;
      $invalidLocation = $location;
    }
  }
  if (valid) {
    $('.location-count').addClass('validationPassed');
    $('button[name=add]').show();
    $('button[name="addClone"]').show();
    $('.validationFailButton').hide();
    injectCheckbox();
  } else {
    $('.location-count').removeClass('validationPassed');
    $('button[name=add]').hide();
    $('button[name="addClone"]').hide();
    $('.validationFailButton').show();
    $('svg.checkmark').remove();
  }
}

function focusUnfilledLocation() {
  var $form = $('form.product-form');
  if ($form.hasClass('singleLocation')) {
    $('textarea[name="properties[Locations]"]')[0].focus();
  } else {
    $('.location-div input').filter(function() {
      return this.value == '';
    })[0].focus();
  }
}

function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function() {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

function initValidation() {
  var $button = $(`
	<button class="validationFailButton btn btn--outline product__submit__add" type="button" onclick="focusUnfilledLocation();">
	  Fill out Locations
	</button>
  `);
  var $button2 = $button.clone();
  $('.product__submit__item').append($button);
  $('.cart-bar__submit').append($button2);
}

function fixCartBar() {
  var $cartBar = $('#cart-bar');
  var $title = $cartBar.find('.cart-bar__product__title');
  var title = $title.text().replace('[', '  •  ').replace(']','');
  $title.text(title);
  var $button = $cartBar.find('button:first');
  $button.attr('name', 'add');
  $button.removeAttr('data-cart-bar-scroll').attr('data-add-to-cart-bar', true);
  $button.removeClass('product__submit__add--chevron');
  $button.removeClass('product__submit__add--default');
  $button.find('span').text('Add to Cart');
}

function initAddToCartSaveCustomization() { // when item is added to cart, clear the product page & localStorage so it now lives in cart instead of page
  $('.product__submit__add').on('click', function() {
    console.log('cartCacheSaved');
    saveCartCache();
    setTimeout(function() {
      console.log('clearProd');
      clearProductCustomization();
    }, 1000);
  });
}

function initCartRemoveRetrieveCustomization() {
  var $btn = null;
  var cartCacheJSON = null;
  $('#cart-dropdown').on('click', '.cart__quantity-minus', function(e) {
    // only if qty is 1 - resulting in no more
    console.log('hhio qty dwon');
    fillCartCache(e.target);
  });
  $('#cart-dropdown').on('click', '.cart-item__remove', function(e) {
    console.log('remove clicked');
    fillCartCache(e.target);
    setTimeout(function() {
      if ($('.cart-item__remove').length == 0) {
        $('.cart-dropdown__close')[0].click();
      }
    }, 1000);
  });
}

function fillCartCache(el) {
  var $cartItem = $(el).closest('.cart-item');
  console.log('fill', $cartItem, $cartItem[0]);
  var cartCacheIndex = $cartItem.attr('cartcacheindex');
  var data = cartCache[cartCacheIndex];
  console.log('data found', data);

  if (!data) return;

  if (location.href.split('?')[0] != data.href.split('?')[0]) {
    // different page
    localStorage.setItem('savedCustomization', JSON.stringify(data));
    cartCache.splice(cartCacheIndex, 1);
    localStorage.setItem('cartCache', JSON.stringify(cartCache));
    setTimeout(function() {
      location.href = data.href;
    }, 1000)
  } else {
    // same page
    fillProductCustomization(data);
    cartCache.splice(cartCacheIndex, 1);
    localStorage.setItem('cartCache', JSON.stringify(cartCache));
    displayMapCountLocations();
    // renderNextLocationButton();
  }
}

function editCartItem(el) {
  $(el).closest('.cart-item').find('.cart-item__remove')[0].click();
  setTimeout(function() {
    console.log('editCartItem');
    if ($('.cart-dropdown').hasClass('is-open')) {
      $('.cart-dropdown__close')[0].click();
    } else {
      setTimeout(function () {
        if ($('.cart-dropdown').hasClass('is-open')) {
          $('.cart-dropdown__close')[0].click();
        }
      }, 1000);
    }
  }, 1000);
}


/*
  Cart Cache works this way,
  when a product is added to cart, the fields on the page are PUSHED as an obj to var cartCache[] before customization is cleared.
  these are added (and saved in localStorage) in sequence
  When a cart item is removed or edited, the corresponding array item is also cleared and pushed back onto the page
*/
function saveCartCache() {
  var data = getProductCustomization();
  data.href = location.href; // in case it's a different page altogether
  
  if ($('body').hasClass('cart-v4')) {
    cartCache.unshift(data);
  } else {
   cartCache.push(data);

  }
  console.log('saved cartCache', data);
  var cartCacheJSON = localStorage.setItem('cartCache', JSON.stringify(cartCache));
}

function loadCartCache() {
  if (!localStorage) return;
  var cartCacheJSON = localStorage.getItem('cartCache');
  if (!cartCacheJSON) return;
  var loadedCache = JSON.parse(cartCacheJSON);
  cartCache = loadedCache;
}

function watchCartInit() {
  // this always looking for cart html (not always present on page load)
  // when it find uninitiated, apply edit button
  setInterval(function() {
    initCartDrawerCache();
  }, 400);

  // see if cart is empty on page load
  var $cartEmpty = $('.cart-dropdown__empty-message ');
  if (!$cartEmpty.hasClass('is-hidden')) {
    cartCache = [];
    localStorage.setItem('cartCache', '[]');
  }
}

function initCartDrawerCache() {  
  var $newCartItem = $(`#cart-dropdown .cart-item:not('.cartCache')`);

  var mapCartIndex = 0; // this only increments on map items, stuff like priority will not increment. Allows reference to cart cache
  for (var i = 0; i < $newCartItem.length; i++) {
    var $cartItem = $($newCartItem[i]);
    // see if it's a map item, which gets edit button
    var maptext = $cartItem.find('p.cart-item__selected-options').text();

    if (maptext.toLowerCase().includes('map count')) {
      $cartItem.attr('cartRealIndex', i);
      $cartItem.attr("cartCacheIndex", mapCartIndex);
      $cartItem.find('.cart__quantity').after(`<button class="cart-item-edit btn btn--outline" type="button" onclick="editCartItem(this)">Edit</button>`);

      // stick the JSON for cart into the attribute of remove elements
      var data = cartCache[mapCartIndex];
      $cartItem.find('.cart__quantity-minus').attr('cartCache', JSON.stringify(data)).attr('cartCacheIndex', mapCartIndex);
      $cartItem.find('.cart-item__remove').attr('cartCache', JSON.stringify(data)).attr('cartCacheIndex',mapCartIndex);

      mapCartIndex++;
    }

    // see if qty > 1
    var qty = +$cartItem.find('.cart__quantity input').val();
    if (qty > 1) $cartItem.find('.cart__quantity').show();

    // add remove button - actually it's just some text now. The original X works fine.
    $cartItem.append('<button disabled class="cartRemove btn btn--outline btn--small" type="button">Remove</button>');

    // adding this class indicates it's been initted
    $cartItem.addClass('cartCache');
  }
  
  if ($('body').hasClass('cart-v2')) formatCartV2();
}

function injectCheckbox() {
  var $exists = $('svg.checkmark');
  if ($exists.length) return;
  $('.product__submit__add').append(`
  	<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
  `);
}

// function fixUpsellTitle() {
//   $('.product-upsell-holder__title').text('Addons to Consider:');
// }

// function injectUpsells() {
//   var prods = [
//     {
//       image: '//cdn.shopify.com/s/files/1/0060/6725/7434/products/Untitled-1_7be6a31e-d56a-4f75-acbb-42287478905f.jpg?v=1656730587',
//       title: 'Priority Service Addon',
//       price: 995,
//       variant_id: 43072251560163,
//       description: 'Get your order 1-2 days sooner',
//       more: '• Skip art queue, faster revisions,<br>• faster handling.<br>• (Expedited shipping separate)',
//       url: '/products/priority-service-addon'
//     },
//     {
//       image: '//cdn.shopify.com/s/files/1/0060/6725/7434/products/istockphoto-1372119871-170667a_2c421567-ab50-4b1f-9a2b-33cd7d12f8cb.jpg?v=1656730583',
//       title: 'Digital Art File Addon',
//       price: 995,
//       variant_id: 39643304820900,
//       description: 'Ready to print, keep, or to share',
//       more: '• Rights to reproduce<br>• 300 dpi printable file',
//       url: '/products/digital-art-file-addon'
//     }
//   ];

//   prods.forEach(product => {
//     // hide the default upsell
//     $('.product-upsell:first').hide();

//     var $upsell = $(`
// 	  <div class="product-upsell" style="margin-bottom: 5px">
//         <div class="product-upsell__image">
// 		  <a href="${product.url}">
//   			<img style="width:120px" src="${product.image.replace('.jpg','_180x.jpg')}" width="120" height="120"  alt="${product.title.replace(' Addon', '')}">
//           </a>
//         </div>
//         <div class="product-upsell__content">
// 		  <a href="${product.url}">
//             <h3 class="product-upsell__title small">${product.title.replace(' Addon', '')}</h3>
//           </a>
//           <p class="product-upsell__price small">
//             <span class="new-price">
//             	<span class="money">$ ${(product.price / 100).toFixed(2)} USD</span>
//             </span>
//           </p>
//     	  <p class="product-upsell-description">${product.description}</p>
//           <a href="javascript:void(0)" onclick="upsellMore(this)">more...</a>
//     	  <p class="product-upsell-description more">${product.more}</p>
//           <form method="post" action="/cart/add" id="product_form_7759454470371" accept-charset="UTF-8" class="shopify-product-form" entype="multipart/form-data">
//             <input type="hidden" name="form_type" value="product">
//             <input type="hidden" name="utf8" value="✓">
//             <input type="hidden" name="id" value="${product.variant_id}">
//             <button type="submit" name="add" data-add-to-cart data-focus-element dat-upsell-btn class="product-upsell__btn">
//               <span class="product-upsell__btn-plus" aria-label="+">
//                 <svg width="10px" height="10px" viewBox="0 0 10 10" class="product-upsell__icon-plus">
//                   <path d="M5,0.5 C5.27614237,0.5 5.5,0.723857625 5.5,1 L5.5,5 L9.5,5 C9.77614237,5 10,5.22385763 10,5.5 C10,5.77614237 9.77614237,6 9.5,6 L5.5,6 L5.5,10 C5.5,10.2761424 5.27614237,10.5 5,10.5 C4.72385763,10.5 4.5,10.2761424 4.5,10 L4.5,6 L0.5,6 C0.223857625,6 3.38176876e-17,5.77614237 0,5.5 C-3.38176876e-17,5.22385763 0.223857625,5 0.5,5 L4.5,5 L4.5,1 C4.5,0.723857625 4.72385763,0.5 5,0.5 Z" fill-rule="nonzero"></path>
//                 </svg>
//               </span>
//               <span class="product-upsell__btn-progress">
//                 <svg height="18" width="18" class="svg-loader">
//                   <circle r="7" cx="9" cy="9"></circle>
//                   <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
//                 </svg>
//               </span>
//               <span class="product-upsell__btn-check">&nbsp;</span>
//             </button>
//           </form>
//         </div>
//       </div>
//     `);

// 	//`
//     // line above is fix for shopify web code highlighter bugging out
//     $('.product-upsell-holder').append($upsell);
//   });
// }

function upsellMore(el) {
  $(el).hide();
  $(el).closest('.product-upsell').find('.product-upsell-description.more').show();
}

function removeFrameTextFromRelatedDesigns() {
  var $titles = $('.recent__wrapper a.product-link p.product__grid__title');

  if ($titles.length == 0) return;
  for (var i = 0; i < $titles.length; i++) {
    var $title = $($titles[i]);
    $title.text($title.text().split('[')[0]);
    $('.recent__wrapper a.product-link p.product__grid__title').text();
  }
  clearInterval(removeFrameTextFromRelatedDesignsInterval);
}

function tryRemoveFrameTextFromRelatedDesigns() {
  removeFrameTextFromRelatedDesignsInterval = setInterval(function() {
    removeFrameTextFromRelatedDesigns();
  }, 990);
}

function hideCustomizationForNonMapProducts() {
  $('.map-info').hide();
  $('.size-popup-link').hide();
  $('[data-product-popup]').hide();
  $('.fake-frame-select').hide();
  $('.product-tabs li').hide();
  $('.product-tabe li:first').show();
  $('#loox-reviews').hide();
  $('#looxReviews').hide();
  $('.shop-pay-terms').hide();
}

function hideProductFrameNamesHomepage() {
  $titles = $('.product-information p.product__grid__title');
  for (var i = 0; i < $titles.length; i++) {
    var $title = $($titles[i]);
    var title = $title.text($title.text().split('[')[0]);
  }
}

function addPersonalizedToTitles() {
  var $exists = $('.personalized-title');
  if ($exists.length) return;
  $('.product__title').before(`
    <span class="personalized-title">➤ personalized</span>
  `);
}

function overrideRecentlyViewed() {
  // override the heading
  $('.recent__title').text('Related Designs');
  // see theme.js => showRecentlyViewed for product overrides
}
// function boldSizeAndFrameLink() {
//   var $link = $('a[data-product-popup="size-template--16155470561507__main"]');
//   $link.css({ "font-size": "0.9rem" });
//   $link.html(`<h6 style="display:inline;line-height:33px;font-size:0.9rem">${$link.text().split('(')[0]}</h6> (${$link.text().split('(')[1]}`);
// }

function initAlternateLocation() {
  var $mapCount = $('[data-select-position=2]');
  $mapCount.addClass("small");
  $mapCount.detach();
  $('.map-info.locations').before($mapCount);
  $mapCount.show();

  // activate events on radio change
  $mapCount.find('span.radio__button').on('click', function() {
    displayMapCountLocations();
    validateLocations();
  });

  var $clone = $('a[data-product-popup="size-template--16155470561507__main"]').clone();
  $clone.css({ color: 'rgb(61, 74, 91)', "margin-top": '20px' });
  $clone.attr('href', 'javascript:void(0);');
  $clone.html('<h6 style="font-size:0.9rem">Map Count</h6>');
  $clone.removeAttr('data-product-popup');
  $('[data-select-position=2]').before($clone);

  $('#nextLocationButton').hide().next().hide();
  $('.location-remove').remove();
}

function formatCartContents() {
  initCartAddons();
  $('.header__cart__status').text(cartCache.length);

  var $items = $('.cart-dropdown__items .cart-item:not(".formatted")');
  for (var i = 0; i < $items.length; i++) {
    var $item = $($items[i]);

    // Put frame into "meta"
    var $title = $item.find('.cart-item__title a');
    var title = $title.text();
    if (title.includes('[')) {
      var frame = title.split('[')[1].split(']')[0];
      $title.text($title.text().replace(`[${frame}]`,''));
      // append the frame in meta
      $item.find('.cart-item__meta').prepend(`
        <p class="cart-item__selected-options cartHasMapItem">
          <strong>Frame:</strong>
          <span>${frame}</span>
        </p>
      `);
    }

    // change Location to just number, and inline it
    var $props = $item.find('p.cart-item__property');
    for (var j = 0; j < $props.length; j++) {
      var $prop = $($props[j]);
      var $propTitle = $prop.find('strong');
      $propTitle.text($propTitle.text().replace('Location ',''));
    }

    $item.addClass('formatted');
    initCartPerks($item);
    checkCartAddon($item);
  }
}
function initCartPerks($item) {
  var $hasMapItem = $item.find('.cartHasMapItem');
  if ($hasMapItem.length) {
    $item.append(`
      <div class="cartItemPerks">⭐ View & Revise before Approval</div>
      <div class="cartItemPerks">⭐ Unlimited Revisions</div>
      <div class="cartItemPerks" style="margin-bottom:-10px;">⭐ Free US Shipping</div>
    `);
  }
}
function initCartFormatting() {
  if ($('.navlink--cart').hasClass('formatInitted')) return;
  setInterval(function() {
    formatCartContents();
  }, 375);
}
// function initCartValidation() {
//   setInterval(function() {
//     validateCart();
//   }, 250);
// }
// function validateCart() {
//   var $cart = $('div.cart-dropdown');
//   var hasMaps = false;

//   var $itemTitles = $('.cart-dropdown__items .cart-item__title');
//   for (var i = 0; i < $itemTitles.length; i++) {
//     var $item = $($itemTitles[i]);
//     if ($item.text().toLowerCase().includes('map')) hasMaps = true;
//   }
//   var $cartFoot = $cart.find(".cart__foot-inner");
//   console.log('hasMaps', hasMaps);
//   if (!hasMaps) {
//     $cartFoot.addClass('validateFailed');
//   } else {
//     $cartFoot.removeClass('validateFailed');
//   }
// }
function initCartAddons() {
  if (location.pathname == '/cart') return;
  if (!$('body[cart-addon]').length) return;
  var $cartWidget = $('form .cart__widget[data-cart-widget]'); // the Add order Notes section
  if ($cartWidget.hasClass('addonsInitted')) return;

    var prods = [
    {
      name: 'priority',
      image: '//cdn.shopify.com/s/files/1/0060/6725/7434/products/Untitled-1_7be6a31e-d56a-4f75-acbb-42287478905f.jpg?v=1656730587',
      title: 'Priority Service',
      price: 995,
      variant_id: 43072251560163,
      description: 'Get your order 1-2 days sooner',
      more: '• Skip art queue, faster revisions,<br>• faster handling.<br>• (Expedited shipping separate)',
      url: '/products/priority-service-addon'
    },
    {
      name: 'digital',
      image: '//cdn.shopify.com/s/files/1/0060/6725/7434/products/istockphoto-1372119871-170667a_2c421567-ab50-4b1f-9a2b-33cd7d12f8cb.jpg?v=1656730583',
      title: 'Digital File',
      price: 995,
      variant_id: 39643304820900,
      description: 'Ready to print, keep, or to share',
      more: '• Rights to reproduce<br>• 300 dpi printable file',
      url: '/products/digital-art-file-addon'
    },
    // {
    //   name: 'calligraphy',
    //   image: '//cdn.shopify.com/s/files/1/0060/6725/7434/products/calligraphy-addon.jpg?v=1656729820',
    //   title: 'Handwritten Calligraphy',
    //   price: 4000,
    //   variant_id: 43089149296867,
    //   description: 'Hand written text by professional Calligrapher',
    //   more: '<a href="https://www.instagram.com/calligraphybyrancy/" target="_blank">Rancy Wong @calligraphybyrancy</a></br>• Scanned onto your artwork.</br>• Limit 2 lines<br>• Click the title for details',
    //   url: '/products/calligraphy-addon'
    // },
  ];

  var cartWidgetBefore = ``;
  prods.forEach(prod => {
    cartWidgetBefore += renderAddon(prod);
  });

  $cartWidget.before(cartWidgetBefore);

  var $cart = $('.form-cart');

  prods.forEach(prod => {
    $cart.before(renderForm(prod));
  });

  $cartWidget.addClass('addonsInitted');
}
function renderAddon(product) {
  return `
    <div class="cart__widget" id="cart__widget_${product.variant_id}">
      <div class="cfg-modal-addon">
        <input onclick="toggleCartVariant(event, ${product.variant_id})" class="unchecked" type="checkbox" name="x-${product.name}" id="variant_id-${product.variant_id}" />
        <label onclick="toggleCartVariant(event, ${product.variant_id})" for="variant_id-${product.variant_id}">${product.title}</label>
        <a href="javascript:showVariantModal(${product.variant_id})">info <b>❏</b></a>

        <span><span>+</span>$${(product.price / 100).toFixed(2)}</span>
      </div>
    </div>
  `;
}
function toggleCartVariant(e, variant_id) {
  e.preventDefault();
  e.stopPropagation();
  setTimeout(function() {
    var $checkbox = $(`input#variant_id-${variant_id}`);
    $checkbox.prop('disabled', true);
    if ($checkbox.is(':checked')) {
      // $checkbox.prop('checked', false);
      removeCartVariant(e, variant_id);
    } else {
      // $checkbox.prop('checked', true);
      addCartVariant(e, variant_id);
    }
  }, 100);
}
function addCartVariant(e, variant_id) {

  $(`#product_form_${variant_id}`).find('button').click();
  $(e.target).prop('checked', true);
}
function removeCartVariant(e, variant_id) {
  e.preventDefault();
  e.stopPropagation();
  var $a = $(`.cart-item__title a[href*=${variant_id}]`);
  if (!$a.length) return;

  var $cartItem = $a.closest('.cart-item');
  if (!$cartItem.length) return;

  var $close = $cartItem.find('.cart-item__remove');
  if (!$close.length) return;
  $close[0].click();
  $(e.target).prop('checked', false);
  $(e.target).closest('.cfg-modal-addon').removeClass('in-cart');
}
function renderForm(product) {
  return `
    <form style="display:none" method="post" action="/cart/add" id="product_form_${product.variant_id}" accept-charset="UTF-8" class="shopify-product-form" entype="multipart/form-data">
      <input type="hidden" name="form_type" value="product">
      <input type="hidden" name="utf8" value="✓">
      <input type="hidden" name="id" value="${product.variant_id}">
      <button id="x-${product.variant_id}" type="submit" name="add" data-add-to-cart data-focus-element dat-upsell-btn>add</button>
    </form>
  `;
}
function checkCartAddon($item) {
  $('input[name*=x-]').prop('disabled', false);
  var variant_id = $item.find('a').attr('href').split('=')[1];
  if (!variant_id) return;
  // search for addon checkbox
  var $checkbox = $(`#variant_id-${variant_id}`);
  if (!$checkbox.length) return;
  $checkbox.prop('checked', true);
  $checkbox.closest('.cfg-modal-addon').addClass('in-cart');
  $item.hide();
  // $item.css({ opacity: 0.5 });
}
function closeModal(e) {
  e.stopPropagation();
  e.preventDefault();
  $('body').removeClass('show-overlay');
}
function showVariantModal(variant_id) {
  var content = {
    // priority
    43072251560163: `
      <h5>Priority Service</h5>
      <p>In a rush? Get your order 1-2 days sooner
      <p>
        <ul>
          <li>Skip the art queue</li>
          <li>Priority revisions</li>
          <li>Priority handling</li>
        </ul>
      </p>
    `,
    // digital
    39643304820900: `
      <h5>Digital Download</h5>
      <p>of your unique artwork. Sent via email after approval, which contains a download link valid for 2 years.</p>
      <p>
        <ul>
          <li>In addition to your print</li>
          <li>300 DPI printable file</li>
          <li>Rights to reproduce</li>
          <li>Printable at home or by any printing service</li>
        </ul>
      </p>
    `,
    // calligraphy
    43089149296867: `
      <h5>Handwritten Calligraphy</h5>
      <p>Support the fine art of Calligraphy, by our LA based partner Rancy Wang
        <a href="https://www.instagram.com/calligraphybyrancy/" target="_blank">IG @calligraphybyrancy</a>
      </p>
      <img style="width:100%" src="https://cdn.shopify.com/s/files/1/0060/6725/7434/products/calligraphy-addon_350x350.jpg?v=1656993984" />
      <p>
        <ul>
          <li>Unlimited Revisions</li>
          <li>Limited to 2 lines of text, Main Text and subtitle. If you require more text please reach out.</li>
          <li><b style="text-decoration:underline;font-style:italic">Handwritten, then scanned onto final print</b>. The ink and paper used in calligraphy is not suitable for mounting and framing</li>
        </ul>
      </p>
    `
  };

  // fake art queue
  var queue = new Date().getMonth() + 8 - (new Date().getHours() % 4);
  content[43072251560163] = content[43072251560163].replace('art queue', `art queue <p class="instruction">(current queue = ${queue})</p>`);

  if (content[variant_id]) {
    $('.cfg-modal-content').html(content[variant_id]);
    $('body').addClass('show-overlay');
  }
}
// function initVariantImageSelection() {
//   $('[data-select-position="1"] span.radio__button input').off('click.variantSelected').on('click.variantSelected', function(e) {
//     var size = $(e.target).attr('value');
//     selectVariantImage(size.replace('×','x'));
//   });
// }
// function selectVariantImage(size) {
//   var frames = {
//     po: 'Print Only',
//     do: 'Digital Only',
//     cw: 'Canvas Wrap',
//     wfc: 'Walnut Canvas',
//     bf: 'Black Frame',
//     wf: 'White Frame'
//   };
//   var frame = frames[getPageFrame()];
//   var $thumb = $(`img.thumb__link__image[alt*="|${size}|"][alt*="${frame}"]`);
//   if ($thumb.length) $thumb.click();
// }
// function initVariantImageOverlay() {
//   var $images = $('.lazy-image:not(".initted")');
//   for (var i = 0; i < $images.length; i++) {
//     var $imageDiv = $($images[i]);
//     var $image = $imageDiv.find('img[data-product-image]');
//     if ($image.attr('alt').includes('[')) {
//       var altString = $image.attr('alt').split('[')[1].split(']')[0];
//       if (altString.includes('|')) {
//         var altSplit = altString.split('|');
//         if (altSplit.length > 2) {
//           var frameDisplay = altSplit[0];
//           if (altSplit[3]) frameDisplay = altSplit[3]; // override
//           $imageDiv.append(`<div class="variantOverlay"><span>shown: ${frameDisplay} | ${altSplit[1].replace('x','×')} | ${altSplit[2]}</span></div>`);
//         }
//       }
//     }
//     $imageDiv.addClass('initted');
//   }
// }

// function renderDeliveryEstimate(min, avg, max, priority_savings, expedited_savings) {
function renderDeliveryEstimate(country) {
  try {
    localStorage.setItem('DE_country', country)
  } catch(e) { console.log(e); }

  $('#deliveryEstimateTitle button.current').removeClass('current');
  $(`button[name=delivery_estimate_${country}]`).addClass('current');
  
  // remove previous version;
  var $dates = $("#deliveryEstimateDates");
  if ($dates.length) $dates.remove();

  var holidays = ['Dec 25', 'Jan 01'];
  var frameType = 'xxx';
  var pageFrame = getPageFrame();
    if (pageFrame == 'bf' || pageFrame == 'po' || pageFrame == 'wf') {
    frameType = 'print';
    frameTypeDisplay = 'Prints & Framed Prints';
  }
  if (pageFrame == 'cw' || pageFrame == 'wfc') {
    frameType = 'canvas';
    frameTypeDisplay = 'Canvas & Framed Canvas';
  }
  if (pageFrame == 'do') frameTypeDisplay = 'Digital Orders';

  var min = DE_OBJ[`${country}_${frameType}_min`];
  var max = DE_OBJ[`${country}_${frameType}_max`];
  console.log('MINMAX', min, max);
  var priority_savings = DELIVERY_ESTIMATES._priority_savings;
  var expedited_savings = DELIVERY_ESTIMATES[`_${country}_ship_exp_savings`];

  if (pageFrame == 'do') {
    min = DELIVERY_ESTIMATES.art_normal_min;
    max = DELIVERY_ESTIMATES.art_normal_max;
  }
  
  var minDate = dateString(dateAdd(min))
  var maxDate = dateString(dateAdd(max));
  if (holidays.includes(minDate)) minDate = dateString(dateAdd(min+1));
  if (holidays.includes(maxDate)) maxDate = dateString(dateAdd(max+1));

  var minDatePriority = dateString(dateAdd(min-Math.round(DELIVERY_ESTIMATES._priority_savings)));
  var maxDatePriority = dateString(dateAdd(max-Math.round(priority_savings)));
  if (holidays.includes(minDatePriority)) minDatePriority = dateString(dateAdd(min+1-Math.round(priority_savings)));
  if (holidays.includes(maxDatePriority)) maxDatePriority = dateString(dateAdd(max+1-Math.round(priority_savings)));

  var minDateBoth = dateString(dateAdd(min-Math.round(priority_savings+expedited_savings)));
  var maxDateBoth = dateString(dateAdd(max-Math.round(priority_savings+expedited_savings)));
  if (holidays.includes(minDateBoth)) minDateBoth = dateString(dateAdd(min+1-Math.round(priority_savings+expedited_savings)));
  if (holidays.includes(maxDateBoth)) maxDateBoth = dateString(dateAdd(max+1-Math.round(priority_savings+expedited_savings)));

  var dateRangeString = `${minDate} to ${maxDate}`;
  var dateRangeStringPriority = `${minDatePriority} to ${maxDatePriority}`;
  var dateRangeStringBoth = `${minDateBoth} to ${maxDateBoth}`;

  var diff = {};
  if (frameType == 'canvas') {
    diff.print = ((min - DE_OBJ[`${country}_print_min`]) + (max - DE_OBJ[`${country}_print_max`])) / -2;
    diff.digital = ((min - DE_OBJ[`${country}_digital_min`]) + (max - DE_OBJ[`${country}_digital_max`])) / -2;
  }
  if (frameType == 'print') {
    diff.canvas = ((min - DE_OBJ[`${country}_canvas_min`]) + (max - DE_OBJ[`${country}_canvas_max`])) / -2;
    diff.digital = ((min - DE_OBJ[`${country}_digital_min`]) + (max - DE_OBJ[`${country}_digital_max`])) / -2;
  }
  if (pageFrame == 'do') {
    // diff.canvas = ((min - DE_OBJ[`${country}_canvas_min`]) + (max - DE_OBJ[`${country}_canvas_max`])) / -2;
    // diff.print = ((min - DE_OBJ[`${country}_print_min`]) + (max - DE_OBJ[`${country}_print_max`])) / -2;
  }
  console.log(diff);

  $('.estimateDiff').remove();
  Object.keys(diff).forEach(key => {
    var display = `${(diff[key] > 0) ? '+ ' : ''}${diff[key]} Day${(diff[key] != 0) ? 's' : ''}`;
    display = display.replace('-','— ');
    console.log(key, display);
    if (key == 'print') {
      $('label:contains("Black Frame"),label:contains("White Frame"),label:contains("Print Only")').closest('.radio__button').append(`<span class="estimateDiff ${(diff[key] > 0) ? 'slower' :''}">${display}</span>`);
    }
    if (key == 'digital') {
      $('label:contains("Digital Only")').closest('.radio__button').append(`<span class="estimateDiff ${(diff[key] > 0) ? 'slower' :''}">${display}</span>`);
    }
    if (key == 'canvas') {
      $('label:contains("Canvas Wrap"), label:contains("Walnut Framed Canvas")').closest('.radio__button').append(`<span class="estimateDiff ${(diff[key] > 0) ? 'slower' :''}">${display}</span>`);
    }
  });
  
  $('#deliveryEstimateTitle').after(`
    <div id="deliveryEstimateDates">
      <p>${dateRangeString} <span class="instructions">standard</span></p>
      <p>${dateRangeStringPriority} <span class="instructions">+🔥priority (see cart)</span></p>
      <p style="${(pageFrame == 'do') ? 'display:none':''}">${dateRangeStringBoth} <span class="instructions">+🔥priority+📦expedited</span></p>
    </div>
  `);
}

function dateAdd(add) {
  var resultDate = new Date(Date.now() + (add+0.4) * 24 * 60 * 60 * 1000);
  return resultDate;
}
function dateString(d) {
  var date_string = d.toString().substring(0, 10);
  var month = date_string.split(' ')[1];
  var date = date_string.split(' ')[2];
  return month + ' ' + date;
}

function initDeliveryEstimate() {
  if (!DELIVERY_ESTIMATES || typeof DELIVERY_ESTIMATES != 'object') return;
  
  var pageFrame = getPageFrame();
  var frameType = 'xxx';
  var frameTypeDisplay = '';
  if (pageFrame == 'bf' || pageFrame == 'po' || pageFrame == 'wf') {
    frameType = 'print';
    frameTypeDisplay = 'Prints & Framed Prints';
  }
  if (pageFrame == 'cw' || pageFrame == 'wfc') {
    frameType = 'canvas';
    frameTypeDisplay = 'Canvas & Framed Canvas';
  }
  if (pageFrame == 'do') frameTypeDisplay = 'Digital Orders';

  // compile some data for detecting holidays and outputs
  var xmas_cutoff = new Date(`${new Date().getFullYear()}-12-23T00:00:00Z`);
  var holiday_begin = new Date(`${new Date().getFullYear()}-11-24T00:00:00Z`);
  var is_holiday = Boolean(new Date() < xmas_cutoff && new Date && new Date() > holiday_begin);

  DE_OBJ.us_canvas_min = Math.ceil(DELIVERY_ESTIMATES._art_min + DELIVERY_ESTIMATES._us_canvas_min + DELIVERY_ESTIMATES._ship_us_min);
  DE_OBJ.us_print_min = Math.ceil(DELIVERY_ESTIMATES._art_min + DELIVERY_ESTIMATES._us_print_min + DELIVERY_ESTIMATES._ship_us_min);
  DE_OBJ.us_digital_min = Math.ceil(DELIVERY_ESTIMATES._art_min);
  DE_OBJ.us_canvas_max = Math.ceil(DELIVERY_ESTIMATES._art_max + DELIVERY_ESTIMATES._us_canvas_max + DELIVERY_ESTIMATES._ship_us_max);
  DE_OBJ.us_print_max = Math.ceil(DELIVERY_ESTIMATES._art_max + DELIVERY_ESTIMATES._us_print_max + DELIVERY_ESTIMATES._ship_us_max);
  DE_OBJ.us_digital_max = Math.ceil(DELIVERY_ESTIMATES._art_max);

  DE_OBJ.canada_canvas_min = Math.ceil(DELIVERY_ESTIMATES._art_min + DELIVERY_ESTIMATES._canada_canvas_min + DELIVERY_ESTIMATES._ship_canada_min);
  DE_OBJ.canada_print_min = Math.ceil(DELIVERY_ESTIMATES._art_min + DELIVERY_ESTIMATES._canada_print_min + DELIVERY_ESTIMATES._ship_canada_min);
  DE_OBJ.canada_digital_min = Math.ceil(DELIVERY_ESTIMATES._art_min);
  DE_OBJ.canada_canvas_max = Math.ceil(DELIVERY_ESTIMATES._art_max + DELIVERY_ESTIMATES._canada_canvas_max + DELIVERY_ESTIMATES._ship_canada_max);
  DE_OBJ.canada_print_max = Math.ceil(DELIVERY_ESTIMATES._art_max + DELIVERY_ESTIMATES._canada_print_max + DELIVERY_ESTIMATES._ship_canada_max);
  DE_OBJ.canada_digital_max = Math.ceil(DELIVERY_ESTIMATES._art_max);

  DE_OBJ.country = 'us';
  try {
    DE_OBJ.country = localStorage.getItem('DE_country') || 'us';
  } catch (e) {}
  
  $('.product__title__wrapper').after(`
    <style>
      #deliveryEstimateTitle {
        margin-top: 23px;
        margin-bottom: 15px;
      }
      #deliveryEstimateTitle span {
        margin-left: 10px;
      }
      .instructions {
        color: #999;
        font-size: 13px;
      }
      #deliveryEstimateTitle button {
        border: 1px solid #ddd;
        font-size: 13px;
        margin-right: 5px;
        padding: 5px 9px;
        margin-left: 5px;
        margin-bottom: -2px;
        vertical-align: bottom;
        opacity: 0.8;
      }
      #deliveryEstimateTitle button.current {
        border: 1px solid #fa7b64;
      }
      .estimateDiff {
        position: absolute;
        top: 29px;
        font-size: 11px;
        letter-spacing: 0.3px;
        width: 100%;
        text-align: center;
        color: #74b641;
        pointer-events: none;
      }
      .estimateDiff.slower {
        color: #ff8888;
      }
    </style>
  `);

  $('.product__title__wrapper').after(`
    <div id="deliveryEstimateTitle">
      <h6 style="font-size: 0.95rem;display:inline">Delivery Estimate</h6>
      <button name="delivery_estimate_us" class="${(DE_OBJ.country == 'us') ? 'current' : ''}" onclick="renderDeliveryEstimate('us')">US</button>
      <button name="delivery_estimate_canada" class="${(DE_OBJ.country != 'us') ? 'current' : ''}" onclick="renderDeliveryEstimate('canada')">Canada</button>
      <span class="instructions" style="display: block;margin-top: 8px;">for ${frameTypeDisplay}</span>
    </div>
  `);
  renderDeliveryEstimate(DE_OBJ.country);

  $('form[data-product-form]').before(`
    <div>
      <p>
        <span class="instructions">*This is an informative estimate based on recent orders. Actual delivery can vary depending on extra revisions or shipping issues.</span>
      </p>
    </div>
  `);
}

async function editCartInline(cartIndex, overrideHandle, overrideSize, overrideMapcount, overrideVariantId, overrideText) {
  console.log('editCartInline args', arguments);
  // get the cart item
  var $cartItem = $(`[cartrealindex="${cartIndex}"]`);
  $cartItem.addClass('editing');

  const cartResponse = await fetch('/cart.js');
  const cartAPI = await cartResponse.json();
  console.log('cart', cartAPI);
  var cartItem = cartAPI.items[cartIndex];
  console.log('cartItem', cartItem);

  $('.cart_update_buttons').remove();

  // initialize the cartItem for editing
  var $cartItem = $(`[cartrealindex="${cartIndex}"]`);
  var $cartItemTitle = $cartItem.find('.cart-item__title');
  $cartItem.addClass("inline-edit");
  $('.cartItemEdit').addClass('editing');

  $('#cart-dropdown').addClass('inline-edit');

  $cartItem.find('.cart-item__meta').hide();
  $cartItem.find('.cart-item-edit').hide();
  
  if (overrideHandle) cartItem.handle = overrideHandle;
  if (overrideSize) cartItem.variant_options[0] = overrideSize;
  if (overrideMapcount) cartItem.variant_options[1] = overrideMapcount;

  var $frames = renderFrameOptions(cartItem.handle, cartIndex, cartItem);

  var response = await renderSizeOptions(cartItem, cartIndex);
  var $sizes = response.$sizes;

  var $mapcounts = renderMapcountOptions(cartItem, cartIndex, response.variants)

  if (overrideSize || overrideMapcount) {
    // frame changed, update the variantId
    for (var i = 0; i < response.variants.length; i++) {
      var variant = response.variants[i];
      if (variant.option1 == cartItem.variant_options[0] && variant.option2 == cartItem.variant_options[1]) {
        cartItem.variantId = variant.id;
        cartItem.id = variant.id;
      }
    }
  }

  if (overrideText) {
    for (var i = 0; i < overrideText.length; i++) {
      var item = overrideText[i];
      if (item.name == 'locations' && item.value) cartItem.properties['Locations'] = item.value;
      if (item.name == 'main_text' && item.value) cartItem.properties['Main Text'] = item.value;
      if (item.name == 'line_2' && item.value) cartItem.properties['Line 2'] = item.value;
      if (item.name == 'line_3' && item.value) cartItem.properties['Line 3'] = item.value;
      if (item.name == 'notes' && item.value) cartItem.properties['Notes'] = item.value;
    }
    console.log('HEYOP override Text', overrideText);
  }

  var $cartEdit = $(`<form class="cartItemEdit" name="cartItemEdit"></form>`);

  $cartEdit.append($frames);
  $cartEdit.append($sizes);
  $cartEdit.append(`<a class="inlineSizeChange" href="javascript:void(0);" onclick="inlineShowOptions(${cartIndex})">⋯</a>`)
  $cartEdit.append($mapcounts);
  $cartEdit.append(`<input type="hidden" name="variantId" value="${cartItem.variant_id}" />`);

  $cartEdit.append(`<input type="hidden" name="cartIndex" value="${cartIndex}" />`)

  // cart edit buttons
   // buttons
  var $cartEditButton = $(`<button type="button" class="btn btn-input">update item</button>`);
  var $cartEditCancel = $(`
    <button type="button" class="btn btn-input btn--outline btn--neutral" style="opacity: 0.8">
      cancel
    </button>  
  `);
  $cartEditButton.on('click', async function () {
    await updateCart(cartAPI);
  });
  $cartEditCancel.on('click', async function(e) {
    await editCartInlineCancel();
    e.stopPropagation();
  });

  var $cartEditButtonDiv = $(`<div class="cart_update_buttons"></div>`);
  $cartEditButtonDiv.append($cartEditButton).append($cartEditCancel);

  $cartItem.find('.cartItemEdit').remove();
  $cartItemTitle.after($cartEdit);
  renderText(cartItem, cartIndex);

  $('.form-cart').prepend($cartEditButtonDiv);
  $cartItem.removeClass('editing');
  applyVariantImageCartInlineEdit(cartIndex);

  // make sure a size is selected, if previous size was 24x24 (canvas only) then choose BF, size will be empty
  var $selectedSize = $cartEdit.find('.inlineSizeEdit li.current');
  if (!$selectedSize.length) {
    // typically it's the largest size that is missing
    $cartEdit.find('.inlineSizeEdit li:last').click();
  }

  // use the size to trigger price and variant updates
  
  setVariantByMapcount($('.inlineMapcountEdit li.current').get(0));
}

function inlineShowOptions(cartIndex) {
  $('.cart-item').addClass('showOptions');
  $('.inlineSizeChange').hide();
}

async function editCartInlineCancel(cartIndex) {
  $('.cartItemEdit').remove();
  $('#cart-dropdown').removeClass('inline-edit');
  $('.cart_update_buttons').remove();
  await cart.getCart();
}

function renderFrameOptions(handle, cartIndex, cartItem) {
  var frames = getFrames(handle);
  console.log('frames', frames);
  var $frames = $(`<div class="inlineFrameEdit"></div>`);
  var currentHandle = '';
  var $ul = $(`<ul></ul>`);
  frames.forEach(frame => {
    if (frame.current) currentHandle = frame.handle;
    var $li = $(`
      <li class="${(frame.current) ? 'current' : ''}" value="${frame.handle}">
        ${frame.text}
      </li>
    `);
    if (!frame.current) {
      $li.on('click', function() {
        var mapcount = $('.cartItemEdit input[name=mapcount]').val();
        var size = $('.cartItemEdit input[name=size]').val();
        var values = $('[name=cartItemEdit]').serializeArray();
        console.log('frame values', values);
        editCartInline(cartIndex, frame.handle, size, mapcount, null, values);
      });
    }
    $ul.append($li);
  });
  $frames.append($ul);
  $frames.append(`<input name="handle" type="hidden" value="${currentHandle.replace('-do', '')}" />`);
  // $frames.append(`<input type="hidden" name="prodId" value="${cartItem.product_id}" />`);
  return $frames;
}

async function renderSizeOptions(cartItem, cartIndex) {
  var variants = await getProductVariants(cartItem.handle);
  var size = '';
  var $cartEdit = $(`[cartrealindex="${cartIndex}"] .cartItemEdit`);
  var $result = $(`<div class="inlineSizeEdit"></div>`);
  console.log('variants', variants);
  var $sizes = $(`<ul></ul>`);
  // size
  variants.options[0].values.forEach(value => {
    var mapcountValues = '';
    for (var i = 0; i < variants.variants.length; i++) {
      var variant = variants.variants[i];
      if (variant.options.includes(value)) {
        if (mapcountValues.length) mapcountValues += ','
        mapcountValues += `${variant.options[1]}:${variant.id}:${variant.price}`;
      }
    }

    var $li = $(`
      <li class="${(cartItem.variant_options.includes(value)) ? 'current' : ''}" value="${value}" variantRef="${mapcountValues}">
        ${value}
      </li>
    `);
    $li.on('click', function(e) {
      setVariantBySize(e.target);
    });
    $sizes.append($li);
    if (cartItem.variant_options.includes(value)) size = value;
  });
  $result.append('<h6 class="inlineSizeEditTitle">Size</h6>')
  $result.append($sizes);
  $result.append(`<input type="hidden" name="size" value="${size}" />`);

  // dirty to do it here but lets update the image from getProductVariants 
  $cartEdit.closest('.cart-item').find('.cart-item__image img').attr('src', variants.imageUrl)

  return {
    $sizes: $result,
    variants: variants
  };
}

function renderMapcountOptions(cartItem, cartIndex, variants) {
 // mapcount
  var mapcount = '';
  var $result = $(`<div class="inlineMapcountEdit"></div>`);

  var $mapcount = $(`<ul></ul>`);
  variants.options[1].values.forEach(value => {
    var sizeValues = '';
    for (var i = 0; i < variants.variants.length; i++) {
      var variant = variants.variants[i];
      if (variant.options.includes(value)) {
        if (sizeValues.length) sizeValues += ','
        sizeValues += `${variant.options[0]}:${variant.id}:${variant.price}`;
      }
    }

    var $li = $(`
      <li style="padding: 6px 12px;" class="${(cartItem.variant_options.includes(value)) ? 'current' : ''}" value="${value}" variantRef="${sizeValues}">
        ${value.replace('Maps', '').replace('Map', '')}
      </li>
    `);
    $li.on('click', function(e) {
      setVariantByMapcount(e.target);
    });
    $mapcount.append($li);
    if (cartItem.variant_options.includes(value)) mapcount = value;
  });
  $result.append('<h6>Location Count</h6>')
  $result.append($mapcount);
  $result.append(`<input type="hidden" name="mapcount" value="${mapcount}" />`);

  return $result;
}

function setVariantBySize(el) {
  $el = $(el);
  $el.closest('ul').find('.current').removeClass('current');
  $el.addClass('current');
  var value = $('form.cartItemEdit input[name=mapcount]').val();

  var dataSplit = $el.attr('variantref').split(',');
  data = {};
  $el.attr('variantref').split(',').forEach(item => {
    data[item.split(':')[0]] = {
      variantId:item.split(':')[1],
      price: item.split(':')[2]
    };
  });
  var variantId = data[value].variantId;
  var price = data[value].price;
  console.log('variantId', variantId, data[value].price);
  $('form.cartItemEdit input[name=variantId]').val(variantId);
  $('form.cartItemEdit input[name=size]').val($el.attr('value'));
  $('.cart-item.inline-edit .cart__price .money').text(`$ ${price.substring(0, price.length-2)}.${price.substring(price.length-2, price.length)} USD`)
  applyVariantImageCartInlineEdit($el.closest('.cart-item').attr('cartcacheindex'));
}

function setVariantByMapcount(el) {
 $el = $(el);
  $el.closest('ul').find('.current').removeClass('current');
  $el.addClass('current');
  var value = $('form.cartItemEdit input[name=size]').val();

  var dataSplit = $el.attr('variantref').split(',');
  data = {};
  $el.attr('variantref').split(',').forEach(item => {
    data[item.split(':')[0]] = {
      variantId:item.split(':')[1],
      price: item.split(':')[2]
    };
  });
  console.log('value', value);
  var variantId = data[value].variantId;
  var price = data[value].price;
  console.log('variantId', variantId, data[value].price);
  $('form.cartItemEdit input[name=variantId]').val(variantId);
  $('form.cartItemEdit input[name=mapcount]').val($el.attr('value'));
  $('.cart-item.inline-edit .cart__price .money').text(`$ ${price.substring(0, price.length-2)}.${price.substring(price.length-2, price.length)} USD`)
}

function getFrames(handle) {
  var possibleSuffixes = ['do', 'po', 'bf', 'wf', 'cw', 'wfc'];
  var suffix = handle.split('-')[handle.split('-').length-1];
  // console.log('suffix', suffix);
  var currentSuffix = 'do';
  var suffixToText = {
    do: 'Digital Only',
    po: 'Print Only',
    bf: 'Black Frame',
    wf: 'White Frame',
    cw: 'Canvas Wrap',
    wfc: 'Walnut Canvas'
  };
  if (possibleSuffixes.includes(suffix)) currentSuffix = suffix;
  var baseHandle = handle.replace(`-${currentSuffix}`,'');
  console.log('baseHandle', baseHandle);
  
  var handles = [];
  possibleSuffixes.forEach(sx => {
    handles.push({
      current: (currentSuffix == sx) ? true : false,
      handle: `${baseHandle}-${sx}`,
      text: suffixToText[sx]
    });
  });
  // console.log('handles', handles);
  return handles;
}

function renderText(cartItem, cartIndex) {
  console.log('cartItem', cartItem);
  var $cartEdit = $(`[cartrealindex="${cartIndex}"] .cartItemEdit`);
  $cartEdit.append('<h6>Your Locations</h6>')
  $cartEdit.append(`<textarea type="text" name="locations">${cartItem.properties['Locations']}</textarea>`);
  $cartEdit.append('<h6>Main Text</h6>')
  $cartEdit.append(`<input type="text" name="main_text" value="${cartItem.properties['Main Text']}" />`);
  $cartEdit.append('<h6>Line 2</h6>')
  $cartEdit.append(`<input type="text" name="line_2" placeholder="optional" value="${cartItem.properties['Line 2']}" />`);
  $cartEdit.append('<h6>Line 3</h6>')
  $cartEdit.append(`<input type="text" name="line_3" placeholder="optional" value="${cartItem.properties['Line 3']}" />`);
  $cartEdit.append('<h6>Notes</h6>');
  $cartEdit.append(`<textarea type="text" name="notes" rows="3">${cartItem.properties['Notes']}</textarea>`);
  $cartEdit.find('textarea').on('input', function(index) {
    textareaHeight(this);
  }).each(function(index) {
    textareaHeight(this);
  });
}

function textareaHeight(el) {
    var value = $(el).val() || '';
    var rowSplit = value.split('\n');
    var rows = rowSplit.length;
    for (var i = 0; i < rowSplit.length; i++) {
      var rowLength = (rowSplit[i]) ? rowSplit[i].length : 0;
      var mod = rowLength % 31;
      var multiple = (rowLength - mod) / 32;
      rows += multiple;
    }
    if (rows < 3) rows = 3;
    console.log("input", rows);
    $(el).attr('rows', rows);
}

async function getProductVariants(handle) {
  handle = handle.replace('-do', '');
  const response = await fetch(`/products/${handle}.js`);
  const product = await response.json();
  console.log('product', product);
  var result = {
    variants: product.variants, // all variants with full data
    options: product.options,    // option names like ["Size", "Color"],
    imageUrl: product.featured_image
  };
  console.log('getProductVariants', result);
  return result;
}

async function updateCart(cartAPI) {
  $('.cartItemEdit').addClass('editing');

  var valuesArr = $('[name=cartItemEdit]').serializeArray();
  var values = {};
  valuesArr.forEach(item => {
    values[item.name] = item.value;
  });
  console.log('values', values);

  var newItems = [];
  for (var i = 0; i < cartAPI.items.length; i++) {
    var cartItem = cartAPI.items[i];
    var newItem = {
      quantity: cartItem.quantity,
      id: cartItem.variant_id,
      properties: cartItem.properties
    };
    console.log('newItem', newItem);

    if (i == values.cartIndex) {
      newItem.id = values.variantId;
      newItem.properties['Main Text'] = values.main_text;
      newItem.properties['Line 2'] = values.line_2;
      newItem.properties['Line 3'] = values.line_3;
      newItem.properties['Locations'] = values.locations;
      newItem.properties['Notes'] = values.notes;

      updateCartCache(values, cartItem);
    }
    // newItems.push(newItem);
    newItems.unshift(newItem);
  }
  console.log('newItems', newItems)
  await fetch(`/cart/clear.js`);
  await fetch(`/cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: newItems
    })
  });
  const cartResponse = await fetch('/cart.js');
  const cartData = await cartResponse.json();
  console.log('cartData', cartData);

  cart.getCart(); // broadcast reload
  $('#cart-dropdown').removeClass('inline-edit');
  $('.cart_update_buttons').remove();
}

function updateCartCache(values, cartItem) {
  var cartCacheIndex = $('.cartItemEdit').closest('.cart-item').attr('cartcacheindex');
  console.log('cartCacheIndex', cartCacheIndex);
  cartCache[cartCacheIndex].href = `https://customfamilygifts.com/products/${values.handle}?variant=${values.variantId}`;
  cartCache[cartCacheIndex].mapCount = values.mapcount;
  cartCache[cartCacheIndex].size = values.size; 
  cartCache[cartCacheIndex]['properties[Main Text]'] = values.main_text;
  cartCache[cartCacheIndex]['properties[Line 2]'] = values.line_2;
  cartCache[cartCacheIndex]['properties[Line 3]'] = values.line_3;
  cartCache[cartCacheIndex]['properties[Locations]'] = values.locations;
  cartCache[cartCacheIndex]['properties[Notes]'] = values.notes;

  console.log('updated cartCache', cartCache[cartCacheIndex]);
  var cartCacheJSON = localStorage.setItem('cartCache', JSON.stringify(cartCache));
}

function initCartV4() {
  // cartCache appears to append new items to array
  // cart API appears to prepend to array
  // visual liquid seems to be 0 on top sequential
  $('body').addClass('cart-v4');
  setInterval(function() {
    var $rawCartItems = $('.cart-item[cartcacheindex]:not(.cart-v4)');
    for (var i = 0; i < $rawCartItems.length; i++) {
      applyCartV4($rawCartItems[i]);
    }
  }, 430);
}

function applyCartV4(cartItem) {
  var $cartItem = $(cartItem);
  $cartItem.addClass('cart-v4');
  var cartIndex = $cartItem.attr('cartcacheindex');
  var cartRealIndex = $cartItem.attr('cartrealindex');
  $cartItem.find('.cart-item__title').after(`<div class="cart-v4-content"></div>`);
  var $cartV4 = $cartItem.find('.cart-v4-content');

  var cartCacheItem = cartCache[cartIndex];
  console.log('v4 cart cache item', cartCacheItem);
  var frame = 'Digital Only';
  // solve for frame
  if (cartCacheItem.href.includes('-bf')) frame = 'Black Frame';
  if (cartCacheItem.href.includes('-wf')) frame = 'White Frame';
  if (cartCacheItem.href.includes('-cw')) frame = 'Canvas Wrap';
  if (cartCacheItem.href.includes('-po')) frame = 'Print Only';
  if (cartCacheItem.href.includes('-wfc')) frame = 'Walnut Canvas';

  console.log('cart 4 frame', frame);
  $cartV4.append(`
    <ul class="cartV4view" style="height:55px;">
      <li>${frame}</li>
      <li>${cartCacheItem.size}</li>
      <br>
      <li>${cartCacheItem.mapCount}</li>
    </ul>
  `);

  $cartV4.append(`<a class="editButtonV4" href="javascript:editCartInline(${cartRealIndex})">edit</a>`)

  $cartV4.append(`<h6 class="cartV4view">Your Locations</h6>`);
  $cartV4.append(`<p class="cartV4view">${textNewlineToLineBreak(cartCacheItem['properties[Locations]'])}</p>`);
  if (cartCacheItem['properties[Main Text]']) {
    $cartV4.append(`<h6 class="cartV4view">Main Text</h6>`);
    $cartV4.append(`<p class="cartV4view">${cartCacheItem['properties[Main Text]']}</p>`);
  }
  if (cartCacheItem['properties[Line 2]']) {
    $cartV4.append(`<h6 class="cartV4view">Line 2</h6>`);
    $cartV4.append(`<p class="cartV4view">${cartCacheItem['properties[Line 2]']}</p>`);
  }
  if (cartCacheItem['properties[Line 3]']) {
    $cartV4.append(`<h6 class="cartV4view">Line 3</h6>`);
    $cartV4.append(`<p class="cartV4view">${cartCacheItem['properties[Line 3]']}</p>`);
  }
  if (cartCacheItem['properties[Notes]']) {
    $cartV4.append(`<h6 class="cartV4view">Notes</h6>`);
    $cartV4.append(`<p class="cartV4view">${textNewlineToLineBreak(cartCacheItem['properties[Notes]'])}</p>`);
  }
}

function applyVariantImageCartInlineEdit(cartIndex) {
  return; // trying the image from getProduct
  var $cartItem = $(`.cart-item[cartrealindex=${cartIndex}]`);
  var product = $cartItem.find('.cart-item__title').text().trim().toLowerCase().split(' ')[0];
  var frame = $cartItem.find('.inlineFrameEdit li.current').text().trim();
  var frameAbbrev = '';
  frame.split(' ').forEach(word => {
    frameAbbrev += word.substring(0, 1).toUpperCase();
  });
  var size = $cartItem.find('input[name=size]').val().replace('×','x');
  console.log(product, frameAbbrev, size);
  var $img = $cartItem.find('.cart-item__image img');
  var filename = `${product}-${frameAbbrev}`;
  if (frameAbbrev != 'DO' && frameAbbrev != 'PO') {
    filename += `-${size}`;
    $img.css({ outline: 'none' });
  } else {
    $img.css({ outline: '1px solid #ddd' });
  }
  filename += '.jpg';
  var imageUrl = `https://cdn.shopify.com/s/files/1/0060/6725/7434/files/${filename}?width=90`;
  $img.attr('src', imageUrl);
}

function textNewlineToLineBreak(text) {
  if (!text) text = '';
  return text.split('\n').join('</br>');
}

/* Klaviyo Add to Cart */
var _learnq = _learnq || [];
function addedToCart() {
  fetch(`${window.location.origin}/cart.js`)
  .then(res => res.clone().json().then(data => {
    var cart = {
      total_price: data.total_price/100,
      $value: data.total_price/100,
      total_discount: data.total_discount,
      original_total_price: data.original_total_price/100,
      items: data.items
    }
    if (item !== 'undefined') {
      cart = Object.assign(cart, item)
    }
    _learnq.push(['track', 'Added to Cart', cart])
  }))
}
(function (ns, fetch) {
  ns.fetch = function() {
    const response = fetch.apply(this, arguments);
    response.then(res => {
      if (`${window.location.origin}/cart/add.js`
      	.includes(res.url)) {
        	addedToCart()
      }
    });
    return response
  }
}(window, window.fetch))
$(document).ajaxComplete(function(event, request, settings){
  if(settings.url == "/cart/add.js"){
      addedToCart()
  }
});
/* Klaviyo Add to Cart END */